module.exports = __webpack_public_path__ + "img/question-3.fcb7f999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svetlana/question-3.png
// module id = 4Z2c
// module chunks = 1